import { clsx } from 'clsx'

const Bone = ({ className }: { className?: string }) => <div className={clsx('animate-pulse bg-semantic-global-border-light', className)} />

export const SkeletonLoader = () => {
  return (
    <div className="flex flex-col gap-semantic-global-xs">
      {/* OnewayReturn toggle row */}
      <Bone className="h-[45px] w-full md:w-[120px]" />

      {/* Selector + button row — mirrors the lg:grid-cols-6 layout */}
      <div className="grid grid-cols-12 gap-semantic-global-xs lg:flex lg:gap-0">
        {/* Routes */}
        <Bone className="col-span-12 h-[58px] md:col-span-6 lg:flex-1" />
        {/* Vehicles */}
        <Bone className="col-span-12 h-[58px] md:col-span-6 lg:flex-1" />
        {/* Passengers */}
        <Bone className="col-span-12 h-[58px] md:col-span-6 lg:flex-1" />
        {/* Dates */}
        <Bone className="col-span-12 h-[58px] md:col-span-6 lg:max-w-[400px] lg:flex-1" />
        {/* Book button */}
        <Bone className="col-span-12 h-[58px] md:col-span-12 lg:ml-auto lg:w-[160px] lg:flex-none" />
      </div>
    </div>
  )
}
